import {
  ascend,
  filter,
  map,
  pathOr,
  pipe,
  prop,
  propEq,
  sort,
  values
} from 'ramda';
import { createSelector } from 'reselect';
import { shallow } from 'zustand/shallow';
import { useSportsbookSelector } from '../../store';

export const selectTournamentsByCategoryId = (categoryId, serviceId) =>
  createSelector(
    pathOr({}, ['tournaments', serviceId, 'data']),
    pipe(
      values,
      filter(propEq(categoryId, 'categoryId')),
      sort(ascend(prop('tournamentWeigh'))),
      map(prop('tournamentId'))
    )
  );

export const useTournamentsByCategoryId = (categoryId, serviceId) =>
  useSportsbookSelector(
    selectTournamentsByCategoryId,
    [categoryId, serviceId],
    shallow
  );
